export default __webpack_public_path__ + "static/media/uppdatering2.c1ce70bb.png";